import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IUser, Preferences } from '../common/types/common';

// Define the user state type

const initialState: IUser = {
  id: '',
  username: '',
  first_name: '',
  last_name: '',
  change_password: false,
  role: '',
  isLoggedIn: false,
  preferences: {
    fontSize: 'medium',
  },
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    updateUser: (state, action: PayloadAction<Partial<IUser>>) => {
      return { ...state, ...action.payload };
    },
    updateUserPreferences: (state, action: PayloadAction<Partial<Preferences>>) => {
      return { ...state, preferences: { ...state.preferences, ...action.payload } };
    },
    logout: (state) => {
      state.id = '';
      state.username = '';
      state.first_name = '';
      state.last_name = '';
      state.change_password = false;
      state.role = '';
    },
  },
});

export const { updateUser, updateUserPreferences, logout } = userSlice.actions;

export default userSlice.reducer;
